export default __webpack_public_path__ + "static/media/vic.45449804.png";